import { Slot } from "../Slot/Slot";
import { BrandLine } from "../../components/BrandLine/BrandLine";
import styles from "../layouts.module.scss";
import { LayoutProps } from "../layoutMap";
import { Grid, GridCol } from "../Grid/Grid";

export function Layout6040({ pageConfig, ...standardProps }: LayoutProps) {
  const layoutTestId = pageConfig?.layoutProps?.testId ?? "layout";
  return (
    <div
      className={styles.page}
      data-testid="slotContainer"
      data-layout="Layout6040"
    >
      <Slot
        pageConfig={pageConfig}
        {...standardProps}
        name="header"
        sizes="100vw"
      />
      <main data-testid={layoutTestId} className={styles.main}>
        <Slot
          pageConfig={pageConfig}
          {...standardProps}
          name="top"
          className={styles.top}
          sizes="(min-width: 1248px) 1200px, (min-width: 768px) calc(100vw - 48px), (min-width: 568px) calc(100vw - 32px), 100vw"
        />
        <div className={styles.container}>
          <Grid>
            <GridCol>
              <Slot
                pageConfig={pageConfig}
                {...standardProps}
                name="accessory"
                className={styles.accessory}
                sizes="(min-width: 1248px) 592px, (min-width: 1024px) calc((100vw - 48px) * 0.6), (min-width: 768px) calc((100vw - 48px) * 0.5), (min-width: 568px) calc(100vw - 32px), 100vw"
              />
              <Slot
                pageConfig={pageConfig}
                {...standardProps}
                name="accessory-foot"
                className={styles.accessoryFoot}
                sizes="(min-width: 1248px) 592px, (min-width: 1024px) calc((100vw - 48px) * 0.6), (min-width: 768px) calc((100vw - 48px) * 0.5), (min-width: 568px) calc(100vw - 32px), 100vw"
              />
            </GridCol>
            <GridCol>
              <BrandLine product={standardProps.product} />
              <div className={styles.detailsMediaWrapper}>
                <Slot
                  name="details-media-img"
                  className={styles.detailsMediaImg}
                  pageConfig={pageConfig}
                  {...standardProps}
                  sizes="(min-width: 1248px) 400px, (min-width: 1024px) calc((100vw - 48px) * 0.4 - 80px), (min-width: 768px) calc((100vw - 48px) * 0.5 - 48px), (min-width: 568px) calc(100vw - 64px), calc(100vw - 32px)"
                />
                <Slot
                  name="details-media-body"
                  className={styles.detailsMediaBody}
                  pageConfig={pageConfig}
                  {...standardProps}
                  sizes="(min-width: 1248px) 400px, (min-width: 1024px) calc((100vw - 48px) * 0.4 - 80px), (min-width: 768px) calc((100vw - 48px) * 0.5 - 48px), (min-width: 568px) calc(100vw - 64px), calc(100vw - 32px)"
                />
              </div>

              <Slot
                pageConfig={pageConfig}
                {...standardProps}
                name="details-head"
                className={styles.detailsHead}
                sizes="(min-width: 1248px) 400px, (min-width: 1024px) calc((100vw - 48px) * 0.4 - 80px), (min-width: 768px) calc((100vw - 48px) * 0.5 - 48px), (min-width: 568px) calc(100vw - 64px), calc(100vw - 32px)"
              />
              <Slot
                pageConfig={pageConfig}
                {...standardProps}
                name="details-body"
                className={styles.detailsMain}
                sizes="(min-width: 1248px) 400px, (min-width: 1024px) calc((100vw - 48px) * 0.4 - 80px), (min-width: 768px) calc((100vw - 48px) * 0.5 - 48px), (min-width: 568px) calc(100vw - 64px), calc(100vw - 32px)"
              />
            </GridCol>
          </Grid>
        </div>
        <Slot
          pageConfig={pageConfig}
          {...standardProps}
          name="bottom"
          className={styles.bottom}
          sizes="(min-width: 1248px) 1200px, (min-width: 768px) calc(100vw - 48px), (min-width: 568px) calc(100vw - 32px), 100vw"
        />
      </main>
      <Slot
        pageConfig={pageConfig}
        {...standardProps}
        name="footer"
        sizes="100vw"
      />
    </div>
  );
}
